import { CurrencyPipe } from '@angular/common'
import { Component, EventEmitter, OnDestroy, OnInit, Output, inject, input, signal } from '@angular/core'
import { ReactiveFormsModule } from '@angular/forms'
import { Router, RouterLink, RouterLinkActive } from '@angular/router'
import { AuthService } from '@auth0/auth0-angular'
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome'
import { NgbDropdownModule, NgbModal, NgbOffcanvas, NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap'
import { Observable } from 'rxjs'
import { AppStore } from 'src/app/core/app.store'
import { CustomerService } from 'src/app/core/services/customer.service'
import { SignalRService } from 'src/app/core/services/signalr-service'
import { PendingAppointmentsPulloutComponent } from 'src/app/shared/components/appointments/pending-appointments-pullout/pending-appointments-pullout.component'
import { BreadcrumbRouterComponent } from 'src/app/shared/components/breadcrumb/breadcrumb-router/breadcrumb-router.component'
import { RecentCustomersPulloutComponent } from 'src/app/shared/components/customer/recent-customers-pullout/recent-customers-pullout.component'
import { BooleanIconComponent } from 'src/app/shared/components/form-elements/boolean-icon/boolean-icon.component'
import { ButtonComponent } from 'src/app/shared/components/form-elements/button/button.component'
import { HeaderTogglerDirective } from 'src/app/shared/components/header/header-toggler/header-toggler.directive'
import { OffCanvasConfig } from 'src/app/shared/components/off-canvas/off-canvas-config'
import { OffCanvasComponent } from 'src/app/shared/components/off-canvas/off-canvas.component'
import { SidebarToggleDirective } from 'src/app/shared/components/sidebar/sidebar-toggle.directive'
import { SidebarTogglerDirective } from 'src/app/shared/components/sidebar/sidebar-toggler.directive'
import { StaffIconHorizontalListComponent } from 'src/app/shared/components/staff/staff-icon-horizontal-list/staff-icon-horizontal-list.component'
import { StaffMapModalComponent } from 'src/app/shared/components/staff/staff-map-modal/staff-map-modal.component'
import { CompanySetting } from 'src/app/shared/interfaces/company-setting/company-setting.interface'

@Component({
    selector: 'sf-header',
    imports: [
        RouterLink,
        RouterLinkActive,
        NgbTooltipModule,
        NgbDropdownModule,
        ReactiveFormsModule,
        ButtonComponent,
        FontAwesomeModule,
        StaffIconHorizontalListComponent,
        OffCanvasComponent,
        BooleanIconComponent,
        BreadcrumbRouterComponent,
        CurrencyPipe,
        HeaderTogglerDirective,
        SidebarToggleDirective,
        SidebarTogglerDirective,
    ],
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss'],
    host: {
        class: 'header header-sticky p-0 mb-4',
    },
})
export class HeaderComponent implements OnInit, OnDestroy {
    appStore = inject(AppStore)
    authService = inject(AuthService)

    #customerService = inject(CustomerService)
    #modalService = inject(NgbModal)
    #offCanvas = inject(NgbOffcanvas)
    #signalRService = inject(SignalRService)

    companySettings$!: Observable<CompanySetting>

    sidebarId = input('sidebar1')

    @Output()
    menuToggle = new EventEmitter()

    showExtendedSettings = signal(false)

    companySettingsOffCanvasConfig: OffCanvasConfig = { position: 'end' }

    ngOnInit(): void {
        this.#customerService.getRecentlyViewedCustomers().subscribe((customers) => {
            this.appStore.setRecentViewedCustomersCount(customers.length)
        })
    }

    testClick(): void {
        this.#signalRService.connection
            .invoke('SendMessageToUser', 'elliottgg', 'Hello from Angular')
            .catch((err) => console.error(err.toString()))
    }

    openRecentCustomersOffCanvas(): void {
        this.#offCanvas.open(RecentCustomersPulloutComponent, { position: 'end' })
    }

    openPendingAppointmentsOffCanvas(): void {
        this.#offCanvas.open(PendingAppointmentsPulloutComponent, { position: 'end' })
    }

    openStaffMapModal(): void {
        this.#modalService.open(StaffMapModalComponent, { size: 'xl', fullscreen: 'lg' })
    }

    toggleMenu(): void {
        this.menuToggle.emit()
    }

    logout(): void {
        this.#signalRService.connection.invoke('LeaveOnlineUsersGroupForCompany')
        this.authService.logout({
            logoutParams: {
                returnTo: window.location.origin,
            },
        })
    }

    ngOnDestroy(): void {
        this.#signalRService.connection.invoke('LeaveOnlineUsersGroupForCompany')
    }
}
